import axios from "axios";
import { CheckboxValueType } from "antd/es/checkbox/Group";
import qs from "qs";
import { getNoWeekTimeCourseList } from "./index";
import Config from "../config";

export interface Ans {
    id: string;
    stuAns: string;
    stuText?: string;
}

export interface TopicsItem {
    index: number;
    contentText: string; //标题
    id: string;
    queTypeId: string; //queTypeId 1,2,3,4,5,6:阅读理解（6以上都有可能多题干）
    typeName: string; //题类型名
    options: OptionItem[];
    zbx: string; //指标项
    stuAns: string;
    stuAnsList: Ans[];
    stuAnsMap: Map<string, { id: string; text: string }>;
}

export enum EvaluateCan {
    no = "0",
    Yes = "1"
}

export interface OptionItem {
    description: string;
    id: string;
    score: string;
    ckdesc: string;
    text?: EvaluateCan;
}

//评教状态
export enum evaluationStatus {
    "NotEvaluated" = "0", //有评教，未经评教
    "Evaluated" = "1", //有评教，已进行评教
    "EvaluationIsNull" = "2" //无评教
}

//题型
export enum evaluationType {
    "radio" = "1",
    "checkbox" = "2",
    "textarea" = "4",
    "radioText" = "a"
}

//题目类别
export enum evaluationGroupType {
    One = "1",
    Many = "2"
}

export interface RadioEventProps {
    onSave: (value: string) => void;
    onChange?: (value: string) => void;
    value?: string | number;
}

export interface CheckboxEventProps {
    onSave: (value: any) => void;
    onChange?: (value: CheckboxValueType[]) => void;
    value?: string[];
}

export interface TextareaEventProps {
    onSave: (value: any) => void;
    onChange?: (value: any) => void;
    value?: string;
}

//学生是否有未完成的评教
export function getStudentEvaluationStatus() {
    return axios
        .get(`/student/evaluation/studentEvaluationStatus`)
        .then(res => res.data.data);
}

//学生是否有未完成的评教
export async function getEvaList(query: evaluationStatus) {
    const batch = localStorage.getItem("batch");
    const data = await getNoWeekTimeCourseList(batch || Config.DefaultBatch);
    return data?.filter(item => {
        return item.evaluationStatus === query;
    });
}

//评教详情
export interface getStuEvlProps {
    evaluationId: string;
}

export interface EvlTeacherInfoProps {
    courseName: string;
    teacherName: string;
    courseNo: string;
    courseSeq: string;
    id: string;
}
export interface StuEvlProps {
    topics: TopicsItem[];
    courseName: string;
    courseNo: string;
    courseSeq: string;
    endTime: string;
    evaluationId: string;
    name: string;
    startTime: string;
    status: evaluationStatus;
    teacherName: string;
    evaluationList: EvlTeacherInfoProps[];
}
export function getStudentEvaluation(params: getStuEvlProps) {
    return axios
        .get<SuccessData<StuEvlProps>>(
            `/student/evaluation/studentEvaluation`,
            {
                params
            }
        )
        .then(res => res.data.data)
        .then(data => ({
            ...data,
            topics: data.topics.map((item: TopicsItem, index: number) => ({
                ...item,
                index: index + 1,
                stuAns:
                    item.queTypeId === evaluationType.checkbox
                        ? JSON.parse((item?.stuAns as string) || "[]")
                        : item.stuAns
            }))
        }));
}
//评教详情 一对多

export function getStudentEvaluationMany(params: getStuEvlProps) {
    return axios
        .get<SuccessData<StuEvlProps>>(
            `/student/evaluation/studentEvaluation2`,
            {
                params
            }
        )
        .then(res => res.data.data)
        .then(data => ({
            ...data,
            topics: data.topics.map((item: TopicsItem, index: number) => {
                const stuAnsMap = new Map<
                    string,
                    { id: string; text: string }
                >();
                item.stuAnsList.forEach(AnsItem => {
                    stuAnsMap.set(AnsItem.id, {
                        id:
                            item.queTypeId === evaluationType.checkbox
                                ? JSON.parse(AnsItem?.stuAns || "[]")
                                : AnsItem.stuAns,
                        text: AnsItem?.stuText || ""
                    });
                });
                return {
                    ...item,
                    index: index + 1,
                    stuAnsMap
                    // stuAns:
                    //     item.queTypeId === evaluationType.checkbox
                    //         ? JSON.parse(item?.stuAns || "[]")
                    //         : item.stuAns
                };
            })
        }));
}

//保存单道
export interface saveStudentAnswerProps {
    evaluationId: string;
    questionId: string;
    answer: string | string[];
}
export function saveStudentAnswer(data: saveStudentAnswerProps) {
    return axios
        .post(`/student/evaluation/saveStudentAnswer`, qs.stringify(data))
        .then(data => data.data.data);
}

//提交
export interface SubEvaItemDataProps {
    evaluationId: string;
    id: string;
    value: string | undefined;
}
export interface submitEvaluationProps {
    evaluationId: string;
    data: SubEvaItemDataProps[];
}
export function submitEvaluation(data: submitEvaluationProps) {
    return axios
        .post(`/student/evaluation/submitEvaluation`, data, {
            headers: {
                "Content-Type": "application/json;charset=UTF-8"
            }
        })
        .then(data => data.data.data);
}

interface SpecialData {
    evaluationId: string;
    optionId: string;
    reason?: string;
}

/**
 * 获取特殊评教草稿
 * @param evaluationId
 */
export function studentEvaluationSpecial(
    evaluationId: string
): Promise<SpecialData | undefined> {
    return axios
        .post<SuccessData<string>>(
            "/student/evaluation/studentEvaluationSpecial",
            qs.stringify({ evaluationId })
        )
        .then(res => res.data.data)
        .then(data => (data ? JSON.parse(data) : undefined));
}

/**
 * 获取特殊评教草稿列表
 * @param evaluationIds
 */
export function studentEvaluationSpecialList(evaluationIds: string[]) {
    return Promise.all(
        evaluationIds.map(evaluationId =>
            studentEvaluationSpecial(evaluationId)
        )
    ).then(data => data.filter(item => !!item) as SpecialData[]);
}

/**
 * 特殊评教草稿保存
 * @param data
 */
export function saveStudentSpecialAnswer(data: SpecialData) {
    const answer = JSON.stringify(data);

    return axios.post(
        "/student/evaluation/saveStudentSpecialAnswer",
        qs.stringify({ evaluationId: data.evaluationId, answer })
    );
}

/**
 * 特殊评教提交
 * @param data
 */
export function submitEvaluationSpecial(data: SpecialData[]) {
    return axios.post(
        "/student/evaluation/submitEvaluationSpecial",
        qs.stringify({
            answer: JSON.stringify(
                data.map(item => ({
                    answer: item.optionId,
                    evaluationId: item.evaluationId,
                    reason: item.reason
                }))
            )
        })
    );
}
